import { ControlValueAccessor } from '@angular/forms';

export class BaseControl implements ControlValueAccessor {
  disabled: boolean;
  value: any;

  onChange = (rating: number) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
